import { ConfirmationDialog } from 'app/components/dialogs/ConfirmationDialog';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  errorDescription?: string;
  onClose: () => void;
}
export default function SSOErrorDialog({ errorDescription, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      open
      title={t('sso_error_dialog.title')}
      confirmationLabel={t('sso_error_dialog.actions.submit')}
      onConfirm={onClose}
    >
      <span style={{ display: 'block', marginBottom: '10px' }}>
        {t('sso_error_dialog.subtitle')}
      </span>
      {errorDescription && <span>{errorDescription}</span>}
    </ConfirmationDialog>
  );
}
